<template>
  <div class="wrappertabs">


  <search-group title="" @search="findData" @clear="clearValue" :span="20" :btnOffset="18" :btnSpan="6"
                :multipleLines="false" :inline="true"
                style="padding: 0"
  >
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.projectFid" placeholder="项目名称">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
          <Select v-model="searchData.businessCode" placeholder="费用项">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in typeList" :value="item.value" :key="'keyB2'+index">{{item.text}}</Option>
          </Select>
        </Col>
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                    placeholder="记账日期筛选"></DatePicker>
      </Col>
      <Col span="6">
          <Input placeholder="请搜索合同号" v-model="searchData.condition"></Input>
      </Col>
    </Row>
  </search-group >

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>

</template>

<script type="text/ecmascript-6">
  // import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "@/utils/format";
  // import TableList from 'components/TableList/index';
  import {incomelist,getFzFwf} from "api/gop";
  import {formatMoney} from "@/utils/format";
  import {getProjects} from "@/api/common";


  export default {
    components: {
       // SearchGroup,
      // TableList,
    },
    props: {
      // projectList:{
      //   type:Array,
      //   default:()=>{return []}
      // }
    },
    created(){
      this.getFee();
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data
        let today=new Date()
        this.searchData.createTime=[new Date(today.valueOf()-29*24*60*60*1000),today]
        if(this.projectList && this.projectList.length>0){
          this.searchData.projectFid=this.projectList[0].value
          this.findData()

        }

      }).catch(error => {
      })

    },
    mounted() {

    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          businessCode:this.searchData.businessCode,
          condition:this.searchData.condition,
          projectFid: this.searchData.projectFid,
          startHappenDate: f(this.searchData.createTime[0]),
          endHappenDate:f(this.searchData.createTime[1])

        }
      }
    },
    data() {
      return {
        typeList:[],
        projectList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '出房合同号 ',
            align: 'center',
            key: 'contractCode',
            width: 130,
          },

          {
            title: ' '
          },        {
            title: "起租日",
            align: 'center',
            key: 'startDate',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['startDate'],false))
            }
          },
          {
            title: ' '
          },        {
            title: "到期日",
            align: 'center',
            key: 'endDate',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['endDate'],false))
            }
          },

          {
            title: ' '
          },        {
            title: "费用项 ",
            align: 'center',
            key: 'businessName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "金额",
            align: 'center',
            key: 'incomeMoney',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['incomeMoney']))
            }
          },
          {
            title: ' '
          },
          {
            title: "收入计入日期 ",
            align: 'center',
            key: 'happenDate',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['happenDate'],false))
            },
          },
          {
            title: ' '
          },
          {
            title: "解约日",
            align: 'center',
            key: 'releaseDate',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['releaseDate'],false))
            }

          },
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime: ['', ''],
          condition:''

        },
      }
    },
    methods: {
      getFee(){
        getFzFwf()
        .then(res=>{
          this.typeList = res.data;
        })
      },
      getData(){
        let params={
          type:1,
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        incomelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]

        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
          condition:''
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
